<div class="content-wrapper" cdkDropListGroup>
  <div id="sidebar">
    <header>
      <h2>{{ "settings.add-calculation-step" | transloco }}</h2>
      <h6>{{ editUserandDate }}</h6>
      <div class="ui pointing secondary menu">
        <a class="item blocks-tab active" data-tab="1">{{
          "settings.blocks" | transloco
        }}</a>
        <a class="item sources-tab" data-tab="2">{{
          "settings.data-source" | transloco
        }}</a>
      </div>
    </header>

    <div class="ui tab blocks active" data-tab="1">
      <div class="tab-contents">
        <div
          class="content"
          cdkDropList
          [cdkDropListSortingDisabled]="true"
          cdkDropListHasAnchor
        >
          @if (!calcBlocks) {
          <ng-container *ngTemplateOutlet="loader"></ng-container>
          } @if (calcBlocks?.length > 0) { @for (block of calcBlocks; track
          block) {
          <div class="calc-block" cdkDrag [cdkDragData]="block">
            {{ block.name }}
          </div>
          } } @if (calcBlocks?.length === 0) {
          <div *ngTemplateOutlet="noResults; context: { type: 'block' }"></div>
          }
        </div>
      </div>
    </div>

    <div class="ui tab data-sources" data-tab="2">
      <div class="tab-contents">
        @if (!dataSources) {
        <ng-container *ngTemplateOutlet="loader"></ng-container>
        } @if (dataSources?.length === 0) {
        <div
          *ngTemplateOutlet="noResults; context: { type: 'data source' }"
        ></div>
        } @if (dataSources?.length > 0) { @if (dataSources?.length === 1) {
        <div>
          <h2 class="text">{{ selectedSource?.name }}</h2>
        </div>
        } @if (dataSources?.length > 1) {
        <div class="dropdown-header">
          <div class="ui inline dropdown">
            <div class="source-header">
              <h2 class="text">{{ selectedSource?.name }}</h2>
              @if (dataSources?.length > 1) {
              <i class="chevron down icon"></i>
              }
            </div>
            @if (dataSources?.length > 1) {
            <div class="menu">
              @for (src of dataSources; track src) {
              <div
                class="item"
                (click)="selectSource(src)"
                [ngClass]="{ active: src?.id === selectedSource?.id }"
              >
                {{ src.name }}
              </div>
              }
            </div>
            }
          </div>
        </div>
        }
        <div class="content">
          @if (!selectedSource) {
          <ng-container *ngTemplateOutlet="loader"></ng-container>
          } @if (selectedSource) { @if (selectedSource?.sourceQuestions?.length
          > 0) { @if (selectedSource?.type === 'taxReturn') {
          <div class="taxReturn-dropdowns">
            <p>
              {{ 'settings.may-have-multiple' | transloco: {taxReturnAlias} }}
            </p>
            <!-- default to same year -->
            <mat-select
              class="selection form-control"
              [hidden]="trYears.length <= 1"
              placeholder="Select Year"
              [formControl]="trYearsCtrl"
            >
              @for (option of trYears; track option) {
              <mat-option [value]="option">{{ option.name }}</mat-option>
              }
            </mat-select>
            <!-- default to same type of question -->
            <mat-select
              class="selection form-control"
              [hidden]="trTypeOptions.length <= 1"
              placeholder="Select Type"
              [formControl]="trTypesCtrl"
            >
              @for (option of trTypeOptions; track option) {
              <mat-option [value]="option">{{ option.name }}</mat-option>
              }
            </mat-select>
            <!-- default to same subtype of question -->
            <mat-select
              class="selection form-control"
              [hidden]="trSubtypeOptions.length <= 1"
              placeholder="Select Subtype"
              [formControl]="trSubtypesCtrl"
            >
              @for (option of trSubtypeOptions; track option) {
              <mat-option [value]="option">{{ option.name }}</mat-option>
              }
            </mat-select>
          </div>
          }
          <div
            cdkDropList
            [cdkDropListSortingDisabled]="true"
            cdkDropListHasAnchor
          >
            @for (question of sourceQuestions |
            orderBy:['desc','id']:['desc','asc']; track question) {
            <app-calc-source-question
              [sourceQuestion]="question"
              [prefix]="prefix(selectedSource, question)"
              cdkDrag
              [cdkDragData]="sourceDragData(selectedSource, question)"
              (cdkDragStarted)="draggingSource = true"
              (cdkDragEnded)="draggingSource = false"
            >
            </app-calc-source-question>
            }
          </div>
          } @if (!sourceQuestions || sourceQuestions.length === 0) {
          <div
            *ngTemplateOutlet="noResults; context: { type: 'question' }"
          ></div>
          } }
        </div>
        }
      </div>
    </div>
  </div>

  <ng-template #noResults let-type="type">
    <div class="no-results">
      {{ 'settings.no-type-s-found' | transloco: {type} }}
    </div>
  </ng-template>

  <ng-template #loader>
    <div class="ui active dimmer">
      <div class="ui large loader"></div>
    </div>
  </ng-template>

  <div id="content">
    @if (calcPlan) {
    <app-calc-plan-editor
      [calcPlan]="calcPlan"
      (newPlanLoaded)="newPlanLoaded($event)"
      [draggingSource]="draggingSource"
    >
    </app-calc-plan-editor>
    }
  </div>
</div>
